/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  fromForm as fromFormDto,
  TodoChangeStatusRequestDto,
  TodoChangeStatusResponseDto,
  TodoDetailsDto,
  TodoFormDto,
  TodoListDto,
  toForm as toFormDto,
} from '@gh/builder-shared-data';

export type TodoChangeStatusResponse = TodoChangeStatusResponseDto;
export type TodoChangeStatusRequest = TodoChangeStatusRequestDto;
export type TodoForm = TodoFormDto;
export type TodoDetails = TodoDetailsDto;
export type TodoList = TodoListDto;
export const fromForm = (todo: TodoForm): TodoDetails => fromFormDto(todo); // tslint:disable-line:no-unnecessary-callback-wrapper
export const toForm = (todo: TodoDetails): TodoForm => toFormDto(todo); // tslint:disable-line:no-unnecessary-callback-wrapper
